// extracted by mini-css-extract-plugin
export default {"Healthcare":"Healthcare_Healthcare__9z1v5","healthIntro":"Healthcare_healthIntro__G1by5"};